import React from 'react';
import { Typography } from 'antd';
import { RichTextEditor } from '../../../modules/rich-text';
import { PlainlyFormat } from '../../../modules/rich-text';
import { useResponsiveSizes } from '../../../hooks/use-responsive-sizes';

const { Text } = Typography;

interface RichTextFieldProps {
  field: any;
  value: PlainlyFormat | undefined;
  onChange: (value: PlainlyFormat) => void;
  onBlur?: () => void;
  commonStyle: React.CSSProperties;
  labelStyle: React.CSSProperties;
  error?: string;
}

export const RichTextField: React.FC<RichTextFieldProps> = ({
  field,
  value,
  onChange,
  onBlur,
  commonStyle,
  labelStyle,
  error
}) => {
  const { fontSize } = useResponsiveSizes();

  return (
    <div style={commonStyle}>
      <Text type='secondary' style={{ ...labelStyle, textTransform: 'uppercase' }}>
        {field.label}
      </Text>

      <RichTextEditor
        placeholder={field.placeholder || 'Escribí tu texto aquí...'}
        onChange={onChange}
        onBlur={onBlur}
        hasError={!!error}
        disabled={field.disabled}
        maxLines={field.maxLines}
      />

      {field.description && !error && (
        <Text type='secondary' style={{ fontSize: fontSize.sm, marginTop: 4 }}>
          {field.description}
        </Text>
      )}

      {error && (
        <Text type='danger' style={{ fontSize: fontSize.sm, marginTop: 4 }}>
          {error}
        </Text>
      )}
    </div>
  );
};
